import contact from "@config/contact.json";
import LeadForm from "../components/LeadForm.jsx";
import SectionTitle from "../components/SectionTitle.jsx";

export default function Contact({ t, branding }) {
  return (
    <section className="section-shell py-14">
      <SectionTitle title="Contact Us" text="Reach the Sitaburdi Urban team by phone, WhatsApp, email, or the contact form." />
      <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div className="grid gap-5">
          <article className="premium-card p-6">
            <img src={branding.logo.primary} alt={branding.logo.alt} className="mb-5 h-14" />
            <div className="grid gap-3 leading-7 text-muted">
              <a href={`tel:${contact.phone}`} className="font-bold text-royal">{contact.phone}</a>
              <a href={`mailto:${contact.email}`} className="font-bold text-royal">{contact.email}</a>
              <a href={`https://wa.me/${contact.whatsapp}`} className="font-bold text-success">WhatsApp Integration</a>
              <span>{contact.address}</span>
              <span>{contact.officeHours}</span>
            </div>
          </article>
          <div className="premium-card overflow-hidden p-0">
  <iframe
    title="Sitaburdi Urban Credit Co-operative Society"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.4291106056576!2d79.07521797592639!3d21.135314680540795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c172002f17e3%3A0x2386846db942132c!2sSitabuldi%20Urban%20Credit%20Co.%20Operative%20Society!5e0!3m2!1sen!2sin!4v1782063084603!5m2!1sen!2sin"
    width="100%"
    height="320"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    className="rounded-3xl"
  />
</div>
        </div>
        <LeadForm t={t} type="contact" title="Contact Form" />
      </div>
    </section>
  );
}
